import React, { useEffect, useState } from "react";
import "./User.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { toast } from "react-toastify";
import { api } from "../../../../../../utility/AxiosInceptor";
import { Dialog } from "primereact/dialog";
import EditUser from "./Components/EditUser";
import { useNavigate } from "react-router-dom";
import CommonLoaderBlue from "../../../../../components/Loader/LoaderBlue";
import EmptyUserState from "./Components/EmptyStateScreens/UsersEmptyState/EmptyStateUser";
export default function Users() {
  let navigate = useNavigate();
  const [showEditUser, setShowEditUser] = useState(false);

  const [userTable, setUserTable] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const getAllUsers = async () => {
    try {
      const res = await api.get(
        `/api/web/user/all?company=${JSON.parse(localStorage.getItem("userData")).company}`
      );
      setUserTable(res?.data?.data?.users?.slice(0, 5) || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(
        `${error?.response?.data?.msg ? error?.response?.data?.msg : "Users Fetching Failed"}`
      );
    }
  };
  useEffect(() => {
    getAllUsers();
  }, []);
  return (
    <>
      {!isLoading && userTable.length === 0 ? (
        <EmptyUserState
          setShowEditUser={setShowEditUser}
          isLoading={isLoading}
        />
      ) : (
        <div className="main-user-conatainer">
          <div className="dashboard-users-header flex flex-wrap flex-row justify-content-between align-items-center">
            <h1>Users</h1>
            <div className="flex flex-wrap flex-row justify-content-start align-items-center">
              <button
                className="link-all-crm cursor-pointer"
                onClick={() => {
                  navigate("/manage-user");
                }}
              >
                VIEW ALL
              </button>
              <button
                className="smallbutton cursor-pointer"
                onClick={() => {
                  setShowEditUser(true);
                }}
              >
                ADD NEW
              </button>
            </div>
          </div>
          <DataTable
            headerClassName="header-user-table"
            className="user-table-main"
            value={userTable}
            emptyMessage={
              isLoading ? (
                <div
                  style={{ width: "108.4rem" }}
                  className="flex flex-wrap flex-row justify-content-center align-items-center p-4"
                >
                  <CommonLoaderBlue sizehere={14} color="royalblue" />
                </div>
              ) : (
                <p>No Result Found</p>
              )
            }
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column
              field="_id"
              body={(item) => {
                return item?._id
                  ?.substring(item?._id?.length - 4, item?._id?.length)
                  ?.toUpperCase();
              }}
              header="Id"
            ></Column>
            <Column
              headerClassName="header-user-table"
              field="name"
              header="Name"
            ></Column>
            <Column
              headerClassName="header-user-table"
              field="email"
              header="Email"
            ></Column>
            <Column
              headerClassName="header-user-table"
              field="role.role"
              header="Role"
            ></Column>
          </DataTable>
          <div className="userdialog">
            <Dialog
              header="null"
              headerClassName="edituserdialogheader"
              visible={showEditUser}
              style={{
                width: "71.6rem",
                height: "50rem",
                display: "flex",
                justifyContent: "center",
              }}
              onHide={() => {
                setShowEditUser((prev) => !prev);
              }}
            >
              <EditUser setShowEditUser={setShowEditUser} />
            </Dialog>
          </div>
        </div>
      )}
    </>
  );
}
